import numeral from 'numeral';
import 'numeral/locales';
import Vue from 'vue';
import { abbreviate, bytes, exponential, exposedNumeral, ordinal, percentage, separator, currency } from './filters';
var vueNumeralFilterInstaller = {
    install: function (vue, _a) {
        var _b = (_a === void 0 ? {} : _a).locale, locale = _b === void 0 ? 'en-gb' : _b;
        numeral.locale(locale);
        vue.filter('abbreviate', abbreviate);
        vue.filter('bytes', bytes);
        vue.filter('exponential', exponential);
        vue.filter('numeral', exposedNumeral);
        vue.filter('ordinal', ordinal);
        vue.filter('percentage', percentage);
        vue.filter('separator', separator);
        vue.filter('currency', currency);
    }
};
export default vueNumeralFilterInstaller;
if (typeof window !== 'undefined' && window.Vue) {
    // eslint-disable-next-line no-undef
    Vue.use(vueNumeralFilterInstaller);
}
